import { CalendarX, CalendarOff } from "lucide-react";

interface EmptyStateProps {
  tab: "upcoming" | "past";
}

export const EmptyState = ({ tab }: EmptyStateProps) => {
  return (
    <div className="text-center py-16 space-y-6">
      <div className="relative">
        <div className="w-24 h-24 mx-auto rounded-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 flex items-center justify-center border border-white/10">
          {tab === "upcoming" ? (
            <CalendarX className="w-10 h-10 text-purple-400" />
          ) : (
            <CalendarOff className="w-10 h-10 text-pink-400" />
          )}
        </div>
        <div className="absolute inset-0 w-24 h-24 mx-auto rounded-full bg-gradient-to-br from-purple-500/10 to-pink-500/10 animate-pulse" />
      </div>
      
      <div className="space-y-2">
        <h3 className="text-xl font-semibold text-white">
          {tab === "upcoming" ? "No upcoming events yet" : "No past events found"}
        </h3>
        <p className="text-white/60 max-w-md mx-auto">
          {tab === "upcoming" 
            ? "Follow to get updates when new events are announced!" 
            : "This producer hasn't hosted any events in the past."}
        </p>
      </div>
    </div>
  );
};